import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-text">© Pickl. All rights reserved.</div>
        <div className="footer-links">
          <a href="/privacy/" className="footer-link">
            Privacy Policy
          </a>
          <a href="/tos/" className="footer-link">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
